import { pathOr } from 'ramda'
import React from 'react'
import { useSelector } from 'react-redux'

import { useGetCampaignOptions } from '@/app/module/campaigns/hooks/use-get-campaign-options'
import { OrgReportFilter } from '@/app/module/reports/types'
import { selectUserTimezone } from '@/app/module/user/store/selectors'
import { selectCountriesTimezones, selectDefaultCountryCode } from '@/app/module/utils/store/selectors'

import SpendReportFilter from './spend-report-filter'

type Props = {
  disabled?: boolean
  filter: OrgReportFilter

  onChange?: (filter: OrgReportFilter) => void
}

const SpendReportFilterContainer: React.FC<Props> = ({ disabled, filter, onChange }) => {
  const countriesTimezones = useSelector(selectCountriesTimezones)
  const countryCode = useSelector(selectDefaultCountryCode)
  const timezone = useSelector(selectUserTimezone)
  const timezones = useSelector(pathOr({}, ['utils', 'countriesTimezonesList', 'data']))

  const [campaignsSearch, setCampaignsSearch] = React.useState<string>('')

  const { data: campaignOptions, isFetching: campaignsLoading } = useGetCampaignOptions({
    search: campaignsSearch,
    archived: true,
    launched: true,
  })

  return (
    <SpendReportFilter
      campaignOptions={campaignOptions}
      campaignsLoading={campaignsLoading}
      countriesTimezones={countriesTimezones}
      countryCode={countryCode}
      disabled={disabled}
      filter={filter}
      timezone={timezone}
      timezones={timezones}
      onCampaignsSearch={setCampaignsSearch}
      onChange={onChange}
    />
  )
}

export default SpendReportFilterContainer
